import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useIsEmbeddedInMobileApp } from 'apps/fleet-planner/hooks/useIsEmbeddedInMobileApp'
import { useUserDetails } from 'utils/hooks'
import StepCard from '../StepCard'
import VerifyAccountWithPassword from './components/VerifyAccountWithPassword'
import VerifyAccountWithPhoneNumber from './components/VerifyAccountWithPhoneNumber'
import { useDeleteUserAccountMutation } from './graphql/DeleteUserAccount'

interface IVerifyAccountStepProps {
  onCancel: () => void
}

const VerifyAccountStep = ({ onCancel }: IVerifyAccountStepProps) => {
  const { userDetails } = useUserDetails()
  const { userType } = userDetails || {}
  const mobileApp = useIsEmbeddedInMobileApp()
  const verifyWithPhone = userType === 'driver' && mobileApp
  const history = useHistory()
  const [deleteUserAccount, { loading }] = useDeleteUserAccountMutation({})
  const [errorMessage, setErrorMessage] = useState<string>()

  const verificationSuccessHandler = useCallback(async () => {
    try {
      setErrorMessage('')
      const result = await deleteUserAccount({
        variables: { userId: String(userDetails?.id) },
      })
      if (result.errors?.length) {
        throw new Error(result.errors[0].message)
      }
      if (!result.data?.deleteUserAccount?.success) {
        throw new Error('non-successful deletion')
      }
      // success :)
      history.push('/account-deletion/step/deletion-success')
    } catch (e) {
      setErrorMessage('Sorry, something went wrong.')
    }
  }, [deleteUserAccount, history, userDetails?.id])

  return (
    <StepCard title='Confirm this is Your Account'>
      {verifyWithPhone ? (
        <VerifyAccountWithPhoneNumber
          onCancel={onCancel}
          onVerificationSuccess={verificationSuccessHandler}
          errorMessage={errorMessage}
          loading={loading}
        />
      ) : (
        <VerifyAccountWithPassword
          onCancel={onCancel}
          onVerificationSuccess={verificationSuccessHandler}
          loading={loading}
          errorMessage={errorMessage}
        />
      )}
    </StepCard>
  )
}

export default VerifyAccountStep
